import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Rota raiz redireciona com base no estado de auth (decidido no loader
 * para evitar flash). Loader chama /auth/me; se 200 → /dashboard, senão → /login.
 */
export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    const res = await fetch('/api/auth/me', { credentials: 'include' });
    if (res.ok) {
      throw redirect({ to: '/dashboard' });
    }
    throw redirect({ to: '/login' });
  },
});
